import { apiGet } from "api/callApi";
import InnoIcons from "InnoUI/innoicons";
import { useEffect, useState } from "react";
import theme from "theme";
import Shimmer, { ShimmerWrapper } from "./Shimmer";
import { Popover } from "@InnoUI/";
import TooltipText from "components/TooltipText";

const GetPermission = (props) => {
  const { folderId, isLoading } = props;

  const [permissionData, setPermissionData] = useState(null);

  const getPermission = async () => {
    try {
      const response = await apiGet(`/v1/getpermissions/${folderId}`, false);
      setPermissionData(response.data);
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  useEffect(() => {
    getPermission();
  }, [folderId]);

  if (isLoading || !permissionData) {
    return (
      <>
        <ShimmerWrapper />
        <div style={{ padding: "5px" }}>
          <Shimmer height="22px" width="20%" />
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <Shimmer height="22px" width="100%" />
            <Shimmer height="22px" width="100%" />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div>
        <span
          style={{
            fontWeight: "bold",
            fontSize: "14px",
            padding: "0px 10px 0px 10px",
          }}
        >
          {permissionData?.folderName || ""}
        </span>
      </div>

      <div>
        {permissionData?.readRoles?.length > 0 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              textAlign: "center",
              marginRight: "10px",
            }}
          >
            <span>
              <InnoIcons.VisibilityIcon
                sx={{
                  fontSize: "15px",
                  margin: "0px 3px -2px 10px",
                  color: theme.colors.themeColor,
                }}
              />
            </span>

            <Popover
              sx={{
                cursor: "pointer",
              }}
              buttonLabel={{
                icon: (
                  <TooltipText
                    title={permissionData.readRoles
                      .map((item) => item.name)
                      .join(", ")}
                    maxLength={130}
                    style={{ fontSize: "14px" }}
                  />
                ),
              }}
              popoverContent={
                <table style={{ width: "200px" }}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          color: theme.colors.themeColor,
                          borderBottom: `1px solid ${theme.colors.bordertask}`,
                          textAlign: "left",
                        }}
                      >
                        Roles
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ marginBottom: "20px" }}>
                      <td
                        style={{
                          borderBottom: `1px solid ${theme.colors.bordertask}`,
                        }}
                      >
                        {permissionData.readRoles
                          .map((item) => item.name)
                          .join(", ")}
                      </td>
                    </tr>
                  </tbody>
                </table>
              }
            />
          </div>
        )}
        {permissionData?.writeRoles?.length > 0 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <span>
              <InnoIcons.EditIcon
                sx={{
                  fontSize: "14px",
                  margin: "0px 3px -2px 10px",
                  color: theme.colors.themeColor,
                }}
              />
            </span>

            <Popover
              sx={{
                cursor: "pointer",
              }}
              buttonLabel={{
                icon: (
                  <TooltipText
                    title={permissionData.writeRoles
                      .map((item) => item.name)
                      .join(", ")}
                    maxLength={130}
                    style={{ fontSize: "14px" }}
                  />
                ),
              }}
              popoverContent={
                <table style={{ width: "200px" }}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          color: theme.colors.themeColor,
                          borderBottom: `1px solid ${theme.colors.bordertask}`,
                          textAlign: "left",
                        }}
                      >
                        Roles
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ marginBottom: "20px" }}>
                      <td
                        style={{
                          borderBottom: `1px solid ${theme.colors.bordertask}`,
                        }}
                      >
                        {permissionData.writeRoles
                          .map((item) => item.name)
                          .join(", ")}
                      </td>
                    </tr>
                  </tbody>
                </table>
              }
            />
          </div>
        )}
      </div>
    </>
  );
};

export default GetPermission;
